import { useRecords } from "./useRecords";
import { useUser } from "./useAuth";
import { startOfWeek, endOfWeek } from "date-fns";
import { sortBy } from "lodash";

export const TECHNICIAN_WEEK_CLINICS_QUERY_KEY_VALUE = "technician-current-week-clinics";

// get the clinics alocated to the clients of the technician in the current week
export const useTechnicianCurrentWeekSessionsClinics = () => {
	const { data: currentUser, status: currentUserStatus } = useUser();

	const startOfWeekDate = startOfWeek(new Date(), { weekStartsOn: 1 });
	const endOfWeekDate = endOfWeek(new Date(), { weekStartsOn: 1 });

	const { data: sessions, status: sessionsStatus } = useRecords("sessions", "clinic_id", {
		extraOptions: {
			filter: {
				_and: [
					{ technician: { user_id: { _eq: currentUser?.id } } },
					{ start_date: { _gte: startOfWeekDate.toISOString() } },
					{ start_date: { _lte: endOfWeekDate.toISOString() } },
					{ status: { _neq: "done" } },
				],
			},
		},
		queryKeyExtraValue: TECHNICIAN_WEEK_CLINICS_QUERY_KEY_VALUE,
		enabled: currentUserStatus === "success",
	});

	const isStatusSuccess = sessionsStatus === "success" && currentUserStatus === "success";
	const isStatusLoading = sessionsStatus === "loading" || currentUserStatus === "loading";
	const isStatusError = sessionsStatus === "error" || currentUserStatus === "error";
	const clinicIds = isStatusSuccess ? sessions?.items.map((session: any) => session.clinic_id) : [];
    
	const uniqueClinicIds = sortBy(Array.from(new Set(clinicIds)).filter(Boolean))
	return { uniqueClinicIds: uniqueClinicIds as Array<number>, isStatusSuccess, isStatusLoading, isStatusError };
};
